module.exports = "/0e8d9e4c10ecc96ae93aaa2b69d940f1c8363bc3/102bfa6b6978940ca3d8d942e3b31097.svg";